import {CouponInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {COLORS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {RefObject} from 'react';
import {CoinsWalletHeader} from '../../../../features/Coins/CoinsWallet/CoinsWalletHeader/CoinsWalletHeader';
import {RequestFailure} from '../../../../features/Coins/shared/RequestFailure';
import {CouponWalletHeader} from '../../../../features/Coupons/CouponWallet/CouponWalletHeader';
import {WalletContentViewProps} from '../WalletContent/WalletContentView';

export const WalletHeader: React.FC<
  WalletContentViewProps & {
    handleInfoIconClick: (couponInfo?: CouponInfoSheet) => void;
    onCloseInfoSheet: RefObject<VoidFunction | undefined>;
    setHeaderHeight: (height: number) => void;
  }
> = ({
  tabs,
  activeTab,
  setSelectedProduct,
  handleInfoIconClick,
  onCloseInfoSheet,
  setHeaderHeight,
}) => {
  const hasError = tabs.some(
    tab =>
      tab.type?.$case === 'coinsError' || tab.type?.$case === 'couponsError',
  );

  return (
    <Container
      ref={ref => {
        if (ref) {
          setHeaderHeight(ref.clientHeight);
        }
      }}
      $hasError={hasError}
    >
      {tabs.map(tab => {
        switch (tab.type?.$case) {
          case 'coins':
            return (
              <TransitioningTab
                data-active={activeTab === 'coins'}
                tabIndex={activeTab === 'coins' ? 0 : -1}
                data-tab="coins"
                aria-hidden={activeTab !== 'coins'}
              >
                <CoinsWalletHeader key={tab.title} {...tab.type.coins.header} />
              </TransitioningTab>
            );
          case 'coupons':
            return (
              <TransitioningTab
                data-active={activeTab === 'coupons'}
                tabIndex={activeTab === 'coupons' ? 0 : -1}
                data-tab="coupons"
                aria-hidden={activeTab !== 'coupons'}
              >
                <CouponWalletHeader
                  key={tab.title}
                  header={tab.type.coupons.header}
                  setSelectedProduct={setSelectedProduct}
                  paused={!!tab.pausedModal}
                  handleCouponInfoClick={handleInfoIconClick}
                  onCloseInfoSheet={onCloseInfoSheet}
                />
              </TransitioningTab>
            );
          case 'coinsError':
            return activeTab === 'coins' ? (
              <StyledRequestFailure key={tab.title} />
            ) : null;
          case 'couponsError':
            return activeTab === 'coupons' ? (
              <StyledRequestFailure key={tab.title} />
            ) : null;
          default:
            return null;
        }
      })}
    </Container>
  );
};

const Container = styled.div<{$hasError: boolean}>`
  display: flex;
  position: relative;
  height: ${props => (props.$hasError ? '100%' : 'max-content')};
`;

const TransitioningTab = styled.div`
  flex: 1;
  position: absolute;
  width: 100%;
  height: 100%;

  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

  opacity: 1;

  &[data-active='true'] {
    position: relative;
    transform: translateX(0);
  }

  &[data-active='false'][data-tab='coins'] {
    opacity: 0;
    visibility: hidden;
  }

  &[data-active='false'][data-tab='coupons'] {
    transform: translateX(100%);
    visibility: hidden;
  }
`;

const StyledRequestFailure = styled(RequestFailure)`
  padding-top: 8rem;
  height: 100%;
  background-color: ${COLORS.Grey4};
`;
